/** Canva-style pastel palette for app card banners. Dark text sits on every shade. */
const PASTEL_PALETTE = [
  "#B4F0F0",
  "#FFDECF",
  "#BCE7FF",
  "#D2FFE6",
  "#FFE7A3",
  "#E7DBFF",
  "#FFD6D8",
  "#C7F0D8",
  "#FFF1C2",
  "#DDE7FF",
  "#FCE1F0",
  "#D6F5E3",
];

/** Stable string → int hash so an app always gets the same colour. */
function hashName(name: string): number {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
}

/** Pastel banner colour for an app, keyed off its stable name. */
export function appBannerColor(name: string): string {
  return PASTEL_PALETTE[hashName(name) % PASTEL_PALETTE.length];
}

/** Vivid hue (0–359) used for the letter-tile logo fallback. */
export function appHue(name: string): number {
  return hashName(name) % 360;
}
